import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import components from '@/components/UI'
import "./assets/main.css";
import posthog from 'posthog-js'

posthog.init(process.env.VUE_APP_POSTHOG_KEY as string, {
  api_host: process.env.VUE_APP_POSTHOG_HOST,
})

const app = createApp(App)

components.forEach(component => {
   app.component(component.name, component)
})

app
   .use(store)
   .use(router)
   .use(i18n)
   .mount('#app')

router.afterEach((to) => {
  posthog.capture('$pageview', { $current_url: window.location.href })
})
